import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import Icon from "@/modules/vue/components/Icon.vue";
import { ColorEnum } from "@/modules/vue/enums";
import { generateColorMap } from "@/modules/vue/utils";
export default /*#__PURE__*/_defineComponent({
  __name: 'Star',
  props: {
    color: {
      default: ColorEnum.Yellow
    },
    enhanced: {
      type: Boolean
    },
    half: {
      type: Boolean
    },
    empty: {
      type: Boolean
    },
    size: null
  },
  setup(__props) {
    const props = __props;
    const colorClassesMap = generateColorMap({
      text: 500
    });
    const icon = computed(() => {
      if (props.enhanced) {
        return IconEnum.StarEmphasis32Filled;
      }
      if (props.empty) {
        return IconEnum.Star16Regular;
      }
      if (props.half) {
        return IconEnum.StarHalf24Filled;
      }
      return IconEnum.Star16Filled;
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_unref(colorClassesMap)[__props.color], "inline-flex items-center"])
      }, [_createVNode(Icon, {
        icon: _unref(icon),
        size: __props.size
      }, null, 8, ["icon", "size"])], 2);
    };
  }
});